export const home = {
  // -----
  section01: {
    title: "Tầm quan trọng của màn cửa và mành",
    content: [
      "Màn cửa và mành có mục đích, chức năng và nhiều đặc điểm tương tự nhau. Chúng được thiết kế như bức màn che cửa sổ và thực hiện nhiều nhiệm vụ như ngăn chặn ánh sáng mặt trời, kiểm soát mức độ xuyên thấu của ánh sáng và sự riêng tư.",
      "Với lối sống phát triển nhanh chóng và chất lượng cuộc sống của người dân được cải thiện liên tục, giá trị chức năng của màn cửa và mành đã đạt đến đến giá trị thẩm mỹ và, giờ đây trở thành yếu tố không thể thiếu trong thiết kế nội thất của một ngôi nhà.",
      "Màn cửa có thể dễ dàng trở thành một phần của bất cứ thiết kế nội thất nào nhờ loại, màu sắc và kiểu dáng đa dạng như màn cửa voan, màn cửa chống nắng.",
      "Mành gọn gàng, khả thi và tối giản đồng thời mang lại nhiều sự lựa chọn hơn về thiết kế và lọc ánh sáng.",
    ],
  },
  section02: {
    title: "Bạn sẽ hài lòng với những gì chúng tôi mang lại",
    content: [
      "Bạn đang kiếm thiết kế mới nhất cho việc trang hoàng cửa sổ nhà bạn? Từng màn che cửa sổ được may đo tỉ mỉ theo số đo riêng phù hợp với cửa sổ nhà bạn trong bộ sưu tập của chúng tôi nhất định sẽ mang đến những thiết kế thu hút ánh nhìn của bạn.",
      "Không những thế,  dịch vụ tại nhà tận tâm và đội ngũ tư vấn viên của chúng tôi còn đảm bảo bạn được nhận tất cả những lời tư vấn cần thiết để đưa ra quyết định đúng đắn cho ngôi nhà và lối sống của bạn. Mọi thành phẩm đều sẽ được đo đạc và lắp ráp bởi chuyên gia.",
      "Bạn sẽ hài lòng với rất nhiều điều về chúng tôi nên đừng chần chừ mà hãy đặt lịch hẹn với chúng tôi ngay hôm nay.",
    ],
  },

  section03: {
    title: "Chuyên gia trong lĩnh vực sản xuất và lắp đặt màn che cửa sổ",
    content: [
      "Chúng tôi là nhà cung cấp hàng đầu dịch vụ trang trí cửa sổ chất lượng cao ở khu vực Thành phố Hồ Chí Minh. Chúng tôi chuyên cung cấp màn cửa, rèm cửa, mành, màn sáo và các vật dụng trang trí cửa sổ chất lượng cao khác từ các nhà sản xuất uy tín. ",
      "Với nhiều năm kinh nghiệm, các mối quan hệ của chúng tôi cho phép chúng tôi mang đến cho khách hàng những sản phẩm tốt nhất. Cho dù bạn đang tìm kiếm vật dụng cho cửa sổ ngôi nhà hay văn phòng của bạn, chúng tôi đều có thể cung cấp nhiều loại, kiểu dáng, và màu sắc mà bạn cần với mức giá thấp nhất. Ngoài các sản phẩm chất lượng cao, chúng tôi còn cung cấp dịch vụ lắp đặt chuyên nghiệp, dịch vụ khách hàng xuất sắc và các dịch vụ liên quan khác.",
    ],
  },
  section04: {
    aboutUs_01: {
      title: "100% Satisfaction",
      content:
        "Cho dù nhu cầu của bạn là những tấm màn với phong cách thanh lịch, mành cuốn hay cửa chớp, chúng tôi sẽ hợp tác với bạn để đảm bảo rằng trang bị cửa sổ của bạn không những thoả mãn nhu cầu của bạn về vẻ đẹp kiến trúc mà còn về sự bền bỉ, chắn chắn theo thời gian.",
    },
    aboutUs_02: {
      title: "Personalisation",
      content:
        "Mỗi cá nhân đều là những cá thể độc đáo và riêng biệt. Những thiết kế của chúng tôi mang đến sự đa dạng về kiểu cách, chất vải và hoa văn. Chính vì thế chúng tôi có thể đáp ứng nhu cầu của mọi căn nhà. Hãy cho phép chúng tôi hỗ trợ bạn trong việc làm cho cửa sổ nhà bạn hoàn hảo hơn.",
    },
    aboutUs_03: {
      title: "Warranty",
      content:
        "Chúng tôi bảo hành năm năm cho tất cả các sản phẩm. Mặc dù chúng tôi tự tin vào chất lượng sản phẩm của mình, nhưng chúng tôi rất vui được hỗ trợ bạn nếu bạn gặp phải bất kỳ vấn đề nào.",
    },
    aboutUs_04: {
      title: "We come to you",
      content:
        "Chúng tôi đem đến cho bạn dịch vụ tư vấn và báo giá chuyên nghiệp miễn phí cho ngôi nhà của bạn.",
    },
    aboutUs_05: {
      title: "Customer service",
      content:
        "Bạn sẽ được hưởng tiêu chuẩn dịch vụ khách hàng cao nhất xuyên suốt quá trình từ ​​báo giá cho đến lắp đặt.",
    },
    aboutUs_06: {
      title: "Best price Guarantee",
      content:
        "Chúng tôi luôn cố gắng hết sức để mang đến cho bạn mức giá thấp nhất, nhưng nếu bạn tìm thấy giá cả thấp hơn trên trang web khác, chúng tôi sẽ sẵn lòng điều chỉnh lại mức giá đồng thời gửi tặng bạn ưu đãi 15% cho sản phẩm đó.",
    },
  },
};
